export enum Language {
  EN = 'en',
  ID = 'id',
}

export enum SocialShareEnum {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  INSTAGRAM = 'INSTAGRAM',
}
